import { useEffect, useState } from "react";
import { timing } from "../config";
import { api } from "../lib/api";
import { getNetworkLabel } from "../lib/runtimeConfig";

type HealthState = "unknown" | "ok" | "down";

export function HealthBadge() {
  const [state, setState] = useState<HealthState>("unknown");

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        await api.health();
        if (!cancelled) setState("ok");
      } catch {
        if (!cancelled) setState("down");
      }
    };

    void check();
    const timer = setInterval(() => void check(), timing.healthPollMs);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  const network = getNetworkLabel();
  const title =
    state === "ok" ? "AileFX is online" : state === "down" ? "AileFX is not reachable" : "Checking AileFX…";

  // Without a network name the dot stands alone, so the state is its name.
  return network === null ? (
    <span className={`health-badge health-${state}`} title={title} role="img" aria-label={title}>
      <span className="health-dot" aria-hidden="true" />
    </span>
  ) : (
    <span className={`health-badge health-${state}`} title={title}>
      <span className="health-dot" aria-hidden="true" />
      {network}
    </span>
  );
}
